var __jsx = React.createElement;
import * as React from 'react';
import { SearchInput } from '@bob/design-system';
export function Search(_ref) {
  var engine = _ref.engine,
      placeholder = _ref.placeholder;
  return __jsx(SearchInput, {
    onChange: function onChange(event) {
      engine.query.text(event.target.value);
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter') {
        event.currentTarget.blur();
      }
    },
    placeholder: placeholder,
    value: engine.query.value.text
  });
}